import { ApiCountryKey } from '../types/apiCountryKey'

export const DEFAULT_API_COUNTRY_KEY: ApiCountryKey = 'dk'
